import { Component, OnInit } from "@angular/core";
import LocalizationConstants from "src/app/constants/localization-constants";
import { Tool } from "src/app/models/Tool";
import { ToolDetails } from "src/app/models/ToolDetails";
import { ToolShipping } from "src/app/models/ToolShipping";

@Component({
  selector: "app-tool-status",
  templateUrl: "./tool-status.component.html",
  styleUrls: ["./tool-status.component.scss"],
  standalone: false,
})
export class ToolStatusComponent implements OnInit {
  tool: Tool;
  toolShipping: ToolShipping;
  toolDetails: ToolDetails; // this prop is set by parent component
  localizationConstants = LocalizationConstants;

  ngOnInit(): void {
    this.setToolDetails();
  }

  setToolDetails() {
    this.tool = this.toolDetails.details;
    this.toolShipping = this.toolDetails.shippingDetails;
  }

  showTrackingLink() {
    //* Tracking link equal tracking number if link was not provided
    return this.toolShipping.trackingNumber != this.toolShipping.trackingLink;
  }
}
